<template>
  <div id="app">
    <DeveloperModeIndicator />
    <notifications :duration="5000" animation-name="v-fade-left" position="top right">
      <template slot="body" slot-scope="props">
        <div :class="'custom-template ' + props.item.type">
          <div :class="'custom-template-icon ' + props.item.type">
            <i :class="'fa fa-times-circle'" v-if="props.item.type == 'danger'"></i>
            <i :class="'fa fa-warning'" v-if="props.item.type == 'warn'"></i>
            <i :class="'fa fa-bell'" v-if="props.item.type == 'success'"></i>
          </div>
          <div class="custom-template-content">
            <div class="custom-template-title">
              {{ props.item.type == 'success' ? '' : '' }}
            </div>
            <div class="custom-template-text" v-html="props.item.text"></div>
          </div>
          <div class="custom-template-close" @click="props.close">
            <i class="fa fa-times-circle-o"></i>
          </div>
        </div>
      </template>
    </notifications>
    <!-- Loader starts-->
    <div class="loader-wrapper" :class="{ loderhide: !show }">
      <div class="loader-index">
        <span></span>
      </div>
    </div>
    <!-- Loader ends-->

    <!--<Main/>-->
    <transition name="page">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import DeveloperModeIndicator from './components/DeveloperModeIndicator.vue';
export default {
  components: {
    DeveloperModeIndicator
  },
  name: 'app',
  data() {
    return {
      show: true,
    };
  },
  mounted() {
    if (window.top !== window.self) {
      window.top.location = window.self.location;
    }
    this.timeOut();
  },
  methods: {
    timeOut() {
      var self = this;
      setTimeout(function () {
        self.show = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.loader-wrapper.loderhide {
  display: none;
}
</style>

<style lang="scss">
.bg-gradient-primary {
  background: -webkit-linear-gradient(180deg,
      lighten(#2971ff, 10%),
      darken(#2971ff, 8%));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.custom-th-class {
  width: 2rem !important;
}

.custom-template {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  text-align: left;
  font-size: 13px;
  margin: 5px;
  margin-bottom: 0;
  align-items: center;
  justify-content: center;

  &,
  &>div {
    box-sizing: border-box;
    border-radius: 10px;
  }

  background: #e8f9f0;
  border: 2px solid #d0f2e1;

  .custom-template-icon {
    flex: 0 1 auto;
    font-size: 20px;
    padding: 0 10px;
    text-shadow: 2px 2px 4px #000000;

    // types (green, amber, red)
    &.success {
      color: #15c371;
    }

    &.warn {
      color: #ffb330;
    }

    &.danger {
      color: #ff4438;
    }
  }

  .custom-template-close {
    flex: 0 1 auto;
    padding: 0 20px;
    font-size: 16px;
    opacity: 0.2;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  .custom-template-content {
    padding: 10px;
    flex: 1 0 auto;

    .custom-template-title {
      letter-spacing: 1px;
      //text-transform: uppercase;
      font-size: 10px;
      font-weight: 600;
    }
  }

  // types (green, amber, red)
  &.success {
    background: #e8f9f0;
    border: 2px solid #d0f2e1;
  }

  &.warn {
    background: #fff7eb;
    border: 2px solid #ffd4a0;
  }

  &.danger {
    background: #ffeceb;
    border: 2px solid #ff9790;
  }
}

.v-fade-left-enter-active,
.v-fade-left-leave-active,
.v-fade-left-move {
  transition: all 0.5s;
}

.v-fade-left-enter,
.v-fade-left-leave-to {
  opacity: 0;
  transform: translateX(-500px) scale(0.2);
}

.page-move {
  transition: all 0.5s;
}

.page-enter-active {
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.6, 0.15, 0.35, 0.8);
}

.page-enter,
.page-leave-to {
  opacity: 0;
}
</style>
